import { Skeleton } from "../../ui";
import BuilderPanel from "../../ui/BuilderPanel";
import React from "react";
import { Container } from "../index";

const CartSkeleton = () => {
  return (
    <Container className={`w-full justify-center items-center flex max-w-[600px] h-[100vh]`}>
      <BuilderPanel
        placement={'right'}
        closable={false}
        headerEnd={
          <Skeleton height={44} className="w-48"/>
        }
        headerClass={`p-2`}
        title={
          <div className={'justify-center items-center flex'}>
            <Skeleton height={44} className="w-24"/>
          </div>
        }
        footer={
          <div className={'w-full justify-between items-center flex flex-col'}>
            <div
              className={'w-full text-gray-800 justify-between items-center flex mt-2'}
            >
              <Skeleton height={28} className="w-20"/>
              <Skeleton height={28} className="w-12"/>
            </div>
            <div
              className={'w-full text-sm text-start mb-4'}
            >
              <Skeleton height={20} className={'my-2 w-full'}/>
            </div>
            <div className={'w-full justify-between items-center flex'}>
              <Skeleton height={50} className={'my-2 w-full'}/>
            </div>
          </div>
        }
        showBackdrop={false}
        lockScroll={false}
        isOpen={true}
        bodyStyles={{
          background: '#FFFFFF'
        }}
        containerClass={'w-full h-full rounded'}
      >
        <div className={'h-full w-full'}>
          <div className="flex flex-col my-1 mb-5">
            <div className={'w-full flex justify-between items-center font-black text-base text-slate-900 mb-2'}>
              <div className={'flex-1 flex justify-start items-center'}>
                <Skeleton height={24} className="w-3/4"/>
              </div>
              <Skeleton height={24} className="w-8"/>
            </div>
            <Skeleton height={154} className={'my-2 w-full'}/>
          </div>
          <div className="flex flex-col my-1">
            <div className={'w-full flex justify-between items-center font-black text-base text-slate-900 mb-2'}>
              <div className={'flex-1 flex justify-start items-center'}>
                <Skeleton height={24} className="w-3/4"/>
              </div>
              <Skeleton height={24} className="w-8"/>
            </div>
            <Skeleton height={154} className={'my-2 w-full'}/>
            <Skeleton height={154} className={'my-2 w-full'}/>
          </div>
        </div>
      </BuilderPanel>
    </Container>
  )
}

export default CartSkeleton
